import "core-js/modules/es.function.bind.js";
import { nativeLogin } from '../utils/native';
import { genLoginType } from '../utils/genLoginType';
import enterPage from '../enterPage/index';
import isMiniProgram from '../utils/isMiniProgram';
/**
 * 登录操作
 * @param { Function } callback 回调函数  APP内专用参数，小程序没有这个回调
 * @param { Object } callback 执行上下文  APP内专用参数
 * @param { Boolean } isInvalidToken 是否强制登录  APP内专用参数
 * @param { String } redirect 重定向地址 小程序专用参数  
 */

export default (function (_ref) {
  var _callback = _ref.callback,
      context = _ref.context,
      _ref$isInvalidToken = _ref.isInvalidToken,
      isInvalidToken = _ref$isInvalidToken === void 0 ? false : _ref$isInvalidToken,
      _ref$redirect = _ref.redirect,
      redirect = _ref$redirect === void 0 ? '' : _ref$redirect,
      _ref$needClose = _ref.needClose,
      needClose = _ref$needClose === void 0 ? 0 : _ref$needClose;

  if (isMiniProgram()) {
    enterPage("/pages/auth/auth".concat(redirect ? "?redirect=".concat(encodeURIComponent(redirect), "&type=1") : ''), needClose);
  } else {
    if (_callback && context) {
      _callback = _callback.bind(context);
    }

    genLoginType().then(function (type) {
      nativeLogin({
        zljOpt: {
          type: type
        },
        forceLogin: isInvalidToken,
        callback: function callback(res) {
          _callback && _callback(res);
        }
      });
    });
  }
});